import type { ReactNode } from 'react'
import { FormattedMessage } from 'react-intl'
import { View } from 'react-native'

import { Button } from '@/src/elements/button/default'
import { Icon } from '@/src/elements/media/Icon'
import { Spacer } from '@/src/elements/spacer/Spacer'
import { Typography } from '@/src/elements/text/Typography'
import { TEST_ID } from '@/src/general/constants/testId'
import { ICON } from '@/src/general/enums/icons'

import { AuthPrivacyNotice } from './AuthPrivacyNotice'

type TAuthDetailsScreenProps = {
  title: ReactNode
  children: ReactNode
  isPending: boolean
  isSubmitDisabled: boolean
  isTitleBold?: boolean
  onSubmit: () => void
}

export const AuthDetailsScreen = ({
  title,
  children,
  isPending,
  isSubmitDisabled,
  isTitleBold,
  onSubmit,
}: TAuthDetailsScreenProps): ReactNode => (
  <View className="w-full flex-1 px-6">
    <View className="mx-auto w-full max-w-lg flex-1 justify-between">
      <Spacer y={32} />
      <View className="gap-8">
        <Typography bold={isTitleBold} size="md">
          {title}
        </Typography>
        {children}
      </View>
      <View className="gap-4 pb-1">
        <View>
          <Icon name={ICON.SAFE_SHIELD} className="self-center text-[#6B5E4F]" />
          <AuthPrivacyNotice />
        </View>
        <Button
          colors="primary"
          variant="solid"
          fullWidth
          isLoading={isPending}
          isDisabled={isPending || isSubmitDisabled}
          onPress={onSubmit}
          testID={TEST_ID.ME.AUTHENTICATION.OTP_DETAILS_SUBMIT}
        >
          <FormattedMessage id="words.i-continue" />
        </Button>
      </View>
    </View>
  </View>
)
